import { redirect } from 'react-router';

/**
 * The V1 dashboard is no longer part of the CMS: the V2 design took the
 * "Dashboard" menu entry. The path stays registered as a redirect so bookmarks
 * and links to `/dashboard` keep working — without it the permission loader
 * finds no menu behind the route and sends the operator to `/unauthorized`.
 */
export const dashboardRoute = [
  {
    path: '/dashboard',
    loader: () => redirect('/dashboard-v2'),
  },
];
